export default "__VITE_ASSET__CYxaPYrH__"